import { render, staticRenderFns } from "./AuthorUpload.vue?vue&type=template&id=47d252f6&"
import script from "./AuthorUpload.vue?vue&type=script&lang=js&"
export * from "./AuthorUpload.vue?vue&type=script&lang=js&"
import style0 from "./AuthorUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports